import { render, staticRenderFns } from "./pratica.vue?vue&type=template&id=92195f10"
import script from "./pratica.vue?vue&type=script&lang=js"
export * from "./pratica.vue?vue&type=script&lang=js"
import style0 from "./pratica.vue?vue&type=style&index=0&id=92195f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports